<template>
  <div>
    <div class="admin__a-tab-content admin__a-tab-content--show a-clarification-dialog" v-for="(item, idx) in lot.request.clarifications" :id="idx">
      <date-time tag="label" :value="item.request.time"></date-time>
      <div class="a-container-form">
        <div class="a-label a-label--w-280">{{$t('form.lot.clarification.request')}}:</div>
        <p class="a-input a-input--disabled a-formatted-text">{{item.request.text}}</p>
      </div>

      <div class="a-container-form" v-if="item.request.files.length">
        <div class="a-label a-label--w-280"></div>
        <div>
          <file-link v-for="file in item.request.files"
                     :key="file.uid"
                     :name="file.name"
                     :signed="file.hasSign"
                     :link="externalLink(file.uid)"
                     :size="file.size"
                     @onsigncheck="onRequestFileSignCheckClick(item.num, file.num)">
          </file-link>

          <div class="input-file__item-empty" v-if="item.request.files.length > 1">
            <span class="input-file__name input-file__name_empty "
                  v-t="'labels.download-all-files'"
                  @click="onDownloadRequestAttachmentsClicked(item.num)">
            </span>
          </div>
        </div>
      </div>


      <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CLARIFICATION && item.permissions.CAN_ANSWER_CLARIFICATION">
        <div class="a-container-form">
          <div class="a-label a-label--w-280">{{$t('form.lot.clarification.response')}}:</div>

          <div class="a-form">
            <div class="a-form__container">
              <textarea class="a-textarea " rows="3" v-model="response[item.num].text"></textarea>

              <div>
                <file-link v-for="(fileRecord, idx) of response[item.num].files"
                           :key="fileRecord.file.uid"
                           :name="fileRecord.file.name"
                           removable
                           :link="externalLink(fileRecord.file)"
                           :size="fileRecord.file.size"
                           @remove="response[item.num].files.splice(idx, 1)">
                </file-link>
              </div>

              <file-picker mode="button"
                           :signing="lot.permissions.SHOULD_BE_SIGNED"
                           @prepared="onResponseFileSelected($event, item.num)">
              </file-picker>
            </div>

            <div class="a-form__submit">
              <button class="gui-btn gui-btn--red gui-btn--w-184"
                      @click.prevent="onSendResponseClick(item.num)">{{$t('buttons.send')}}</button>
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="item.response.text || item.response.files.length">
        <date-time tag="label" :value="item.response.time"></date-time>
        <div class="a-container-form a-container-form--align-start">
          <div class="a-label a-label--w-280">{{$t('form.lot.clarification.response')}}:</div>
          <p class="a-input a-input--disabled a-formatted-text">{{item.response.text}}</p>
        </div>

        <div class="a-container-form" v-if="item.response.files.length">
          <div class="a-label a-label--w-280"></div>

          <div>
            <file-link v-for="file of item.response.files"
                       :key="file.uid"
                       :name="file.name"
                       :signed="file.hasSign"
                       :link="externalLink(file.uid)"
                       :size="file.size"
                       @onsigncheck="onResponseFileSignCheckClick(item.num, file.num)">
            </file-link>

            <div class="input-file__item-empty" v-if="item.response.files > 1">
              <span class="input-file__name input-file__name_empty "
                    v-t="'labels.download-all-files'"
                    @click="onDownloadResponseAttachmentsClicked(item.num)">
              </span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CLARIFICATION && lot.request.permissions.CAN_REQUEST_CLARIFICATION">
      <div class="a-container-form">
        <div class="a-label a-label--w-280">{{$t('form.lot.clarification.request')}}:</div>

        <div class="a-form">
          <div class="a-form__container">
            <textarea class="a-textarea " rows="3" v-model="request.text"></textarea>

            <file-link v-for="(fileRecord, idx) of request.files"
                       :key="fileRecord.file.uid"
                       :name="fileRecord.file.name"
                       removable
                       :link="externalLink(fileRecord.file)"
                       :size="fileRecord.file.size"
                       @remove="request.files.splice(idx, 1)">
            </file-link>

            <file-picker :signing="lot.permissions.SHOULD_BE_SIGNED"
                         @prepared="onRequestFileSelected">
            </file-picker>
          </div>
          <div class="a-form__submit">
            <button class="gui-btn gui-btn--red gui-btn--w-184"
                    @click.prevent="onSendRequestClick">{{$t('buttons.send')}}</button>
          </div>
        </div>
      </div>
    </div>
    <signature-details-dialog ref="signCheck"></signature-details-dialog>
    <signing-dialog ref="signClarification"
                    @signed="signClarification">
    </signing-dialog>
  </div>
</template>

<script>
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'

  export default {
    props: {
      lot: Object
    },

    components: {
      SigningDialog,
      SignatureDetailsDialog
    },

    data: () => ({
      request: {
        text: undefined,
        files: []
      },
      response_: {}
    }),

    computed: {
      response: function() {
        for (const item of this.lot.request.clarifications) {
          if (!this.response_[item.num]) {
            this.$set(this.response_, item.num, {
              text: undefined,
              files: []
            });
          }
        }

        return this.response_;
      }
    },

    methods: {
      async prepareAction(text) {
        if (this.lot.permissions.SHOULD_BE_SIGNED) {
          this.$refs.signClarification.open({text});
        }
        else {
          await this.signClarification();
        }
      },

      async onSendRequestClick() {
        this._callback = this.doSendRequestClick.bind(this);
        this.prepareAction(this.text);
      },

      async onSendResponseClick(itemNum) {
        this._callback = this.doSendResponseClick.bind(this, itemNum);
        this.prepareAction(this.response[itemNum].text);
      },

      async doSendRequestClick(signature) {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('requestClarification', {
              requestId: this.lot.request.id,
              text: this.request.text,
              sign: signature,

              files: this.request.files.map(f => ({
                file: f.file,
                fileSign: f.sign
              }))
            });

            this.request = {
              text: undefined,
              files: []
            };

            this.showError({
              title: 'Уточнение заявки',
              error: 'Вопрос на уточнение заявки отправлен'
            })
          }
          catch (e) {
            console.error('failed sending clarification request', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async doSendResponseClick(itemNum, idx, signature) {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('responseClarification', {
              requestId: this.lot.request.id,
              clarificationId: itemNum,
              text: this.response[itemNum].text,

              files: this.response[itemNum].files.map(f => ({
                file: f.file,
                fileSign: f.sign
              })),
              sign: signature
            });

            delete this.response[itemNum];

            this.showError({
              title: 'Уточнение заявки',
              error: 'Ответ на уточнение заявки отправлен'
            })
          }
          catch (e) {
            console.error('failed sending clarification response', e);
            this.globalErrorHandler(e);
          }
        });
      },

      onRequestFileSelected(file, itemNum) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.request.files.push(file);
      },

      onResponseFileSelected(file, itemNum) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.response[itemNum].files.push(file);
      },

      async onRequestFileSignCheckClick(questionId, fileNum) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkClarificationQuestionFileSignature', {
              requestId: this.lot.request.id,
              questionId: questionId,
              fileNum
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onResponseFileSignCheckClick(questionId, fileNum) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkClarificationResponseFileSignature', {
              requestId: this.lot.request.id,
              questionId: questionId,
              fileNum
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async signClarification(result) {
        this.runBlockerAction(async () => {
          try {
            this.$refs.signClarification.close();

            this._callback(result ? result.signature : undefined)
          }
          catch(e) {
            console.error('failed signing request clarification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onDownloadRequestAttachmentsClicked(questionId) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('downloadRequestClarificationAttachments', {
              requestId: this.lot.request.id,
              questionId: questionId
            });
          }
          catch(e) {
            console.error('unable to download all attachments from clarification request', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onDownloadResponseAttachmentsClicked(questionId) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('downloadResponseClarificationAttachments', {
              requestId: this.lot.request.id,
              questionId: questionId
            });
          }
          catch(e) {
            console.error('unable to download all attachments from clarification response', e);
            this.globalErrorHandler(e);
          }
        });
      }
    },
  }
</script>

<style scoped>
  .a-clarification-dialog {
    width: 100%;
    margin-bottom: 20px;
    padding: 27px 26px;
    text-align: left;
    border: 1px solid #C4C4C4;
  }
</style>
